(() => {
  'use strict';
  if (window.DCPdp?.version === 4) {
    window.DCPdp.mount();
    return;
  }
  const instances = new Map();
  function createScope() {
    const controller = new AbortController(),
      frames = new Set();
    return {
      updates: new Set(),
      cleanups: [],
      on(target, type, listener, options = {}) {
        target.addEventListener(type, listener, {
          ...(typeof options === 'boolean' ? { capture: options } : options),
          signal: controller.signal,
        });
      },
      frame(callback) {
        const id = requestAnimationFrame(() => {
          frames.delete(id);
          if (!controller.signal.aborted) callback();
        });
        frames.add(id);
        return id;
      },
      destroy() {
        controller.abort();
        frames.forEach(cancelAnimationFrame);
        this.cleanups.forEach((fn) => fn());
        this.updates.clear();
      },
    };
  }
  function cheapest(needed, one, five) {
    if (!Number.isFinite(needed) || needed <= 0) return null;
    var n = Math.ceil(needed - 1e-9),
      best = null;
    [0, Math.floor(n / 5), Math.ceil(n / 5)].forEach(function (q5) {
      var q1 = Math.max(0, n - q5 * 5);
      if ((q1 && (!one || !one.available)) || (q5 && (!five || !five.available))) return;
      var items = [];
      if (q5)
        items.push({
          id: five.id,
          quantity: q5,
          price: five.price,
          compare: five.compare_at_price || 0,
          size: 5,
        });
      if (q1)
        items.push({
          id: one.id,
          quantity: q1,
          price: one.price,
          compare: one.compare_at_price || 0,
          size: 1,
        });
      var cost = items.reduce(function (s, i) {
          return s + i.price * i.quantity;
        }, 0),
        capacity = q5 * 5 + q1;
      if (!best || cost < best.cost || (cost === best.cost && capacity < best.capacity))
        best = {
          items: items,
          cost: cost,
          capacity: capacity,
          saving: items.reduce(function (s, i) {
            return s + Math.max(0, i.compare - i.price) * i.quantity;
          }, 0),
        };
    });
    return best;
  }

  function cfg(root) {
    if (root._dcCfg) return root._dcCfg;
    var node = root.querySelector('[data-e-config]'), c = {};
    try { c = JSON.parse(node.textContent); } catch (e) {}
    root._dcCfg = c;
    return c;
  }
  function related(root, part) {
    return Array.from(document.querySelectorAll('[data-dc-pdp-part]')).find(
      (el) =>
        el.dataset.productId === root.dataset.productId && el.dataset.dcPdpPart === part,
    );
  }
  function mainFor(root) {
    return Array.from(document.querySelectorAll('[data-dc-pdp]')).find(
      (el) => el.dataset.productId === root.dataset.productId,
    );
  }
  function selection(root) {
    const main = mainFor(root) || root;
    return Array.from(main.querySelectorAll('variant-selects fieldset')).map(
      (f) => f.querySelector('input:checked')?.value || '',
    );
  }
  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }
  function option(v, index) {
    return index >= 0 ? (v.options || [])[index] : '';
  }
  function variantFor(bundle, color, sealer) {
    return bundle?.variants?.find(
      (v) =>
        option(
          v,
          bundle.options.findIndex((o) => /color/i.test(o)),
        ) === color &&
        option(
          v,
          bundle.options.findIndex((o) => /sealer/i.test(o)),
        ) === sealer,
    );
  }
  async function addItems(data, items) {
    const response = await fetch(data.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items.map(({ id, quantity }) => ({ id, quantity })) }),
    });
    const result = await response.json();
    if (!response.ok)
      throw Error(result.description || 'Unable to add these items. Please try again.');
    window.location.assign(data.cartUrl);
  }
  function mountBanner(root, scope) {
    let key = '';
    function sync() {
      const main = mainFor(root),
        gallery = main?.querySelector('media-gallery');
      if (!gallery || !gallery.querySelector('[data-variant-showcase-lookup]')) return;
      const [size, color] = selection(root);
      const mc = cfg(main);
      const lookup = JSON.parse(
          gallery.querySelector('[data-variant-showcase-lookup]').textContent,
        ),
        data = JSON.parse(gallery.querySelector('[data-variant-showcase-data]').textContent),
        photos = data[lookup[[size, color].join('~')]] || [];
      const next = JSON.stringify([color, photos]);
      if (next === key) return;
      key = next;
      const colors = mc.colors || [];
      const projects = photos
        .map((p, i) => ({ ...p, original: i }))
        .filter((p) => {
          const re = new RegExp(mc.packshot || 'gallon|ounce|bottle|pail|jug|_1_Gallon|_5_Gallon|_4_Ounce', 'i');
          return !(re.test(p.a || '') || re.test(p.u || ''));
        })
        .sort((a, b) => {
          const score = (p) =>
            colors.filter((c) => (p.a || '').toLowerCase().includes(c.toLowerCase())).length > 1
              ? 10
              : { Avocado: 4, 'English Red': 4 }[color] === p.original
                ? -1
                : 0;
          return score(a) - score(b) || a.original - b.original;
        })
        .slice(0, 3);
      const collage = root.querySelector('.e-collage');
      collage.replaceChildren();
      projects.forEach((p) => {
        const img = document.createElement('img');
        const url = new URL(p.u, location.href);
        url.searchParams.set('width', '640');
        img.src = url.href;
        img.alt = '';
        img.title = p.a;
        img.width = 640;
        img.height = 640;
        img.loading = 'lazy';
        collage.append(img);
      });
      const d = root.dataset;
      const special = Object.fromEntries((d.eSlugs || '').split('\n').map((l) => l.split('|').map((x) => x.trim())).filter((x) => x.length > 1));
      const slug = special[color] || (color || '').toLowerCase().replaceAll(' ', '-');
      if (color && d.eLink) root.querySelector('.e-gallery-banner').href = d.eLink.replace('{color}', slug);
      if (color && d.eLabel) setText(root.querySelector('[data-e-banner-title]'), d.eLabel.replace('{color}', color));
    }
    scope.on(document, 'dc:pdp-selection', sync);
    scope.on(document, 'change', (e) => {
      if (e.target.closest('[data-dc-pdp]')) scope.frame(sync);
    });
    scope.updates.add(sync);
    sync();
  }
  function mountTools(root, scope) {
    const data = JSON.parse(root.querySelector('[data-e-tools-catalog]').textContent);
    var noun = root.dataset.eNoun || 'stain';
    const currency = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: data.currency || 'USD',
    });
    const money = (cents) => currency.format(cents / 100);
    let busy = false;
    var calculatedItems = [],
      calculatedValid = false,
      calculatedNeedsDimensions = true;
    var calculated = document.createElement('div');
    calculated.className = 'e-calculated-bundle';
    calculated.innerHTML =
      '<label class="e-calc-bundle-toggle"><input type="checkbox"><span><strong>Add neutralizer + sealer</strong><small data-calc-saving>Complete your project with matched quantities</small></span></label><div class="e-calc-sealers" hidden><label>Choose your sealer<select aria-label="Calculator sealer"><option value="">Select a sealer</option></select></label></div>';
    var calcCheck = calculated.querySelector('input'),
      calcSealers = calculated.querySelector('.e-calc-sealers'),
      calcSelect = calculated.querySelector('select'),
      calcSaving = calculated.querySelector('[data-calc-saving]'),
      calcSealer = '',
      calcOptionsKey = '';
    if (!data.bundles.length) calculated.querySelector('.e-calc-bundle-toggle').remove();   // nothing to add: no neutralizer + sealer offer
    var calculatedSummary = document.createElement('p'),
      calculatedButton = document.createElement('button');
    calculatedSummary.setAttribute('aria-live', 'polite');
    calculatedButton.type = 'button';
    calculatedButton.textContent = 'Add calculated bundle to cart';
    calculated.append(calculatedSummary, calculatedButton);
    var recipe = root.querySelector('.dc-calculator__recipe');
    if (recipe) recipe.append(calculated);
    scope.on(calcCheck, 'change', sync);
    scope.on(calcSelect, 'change', function () {
      calcSealer = calcSelect.value;
      sync();
    });
    scope.on(calculatedButton, 'click', function () {
      sync();
      if (busy) return;
      if (calculatedNeedsDimensions) {
        var calculator = root.querySelector('.dc-calculator'),
          fields = Array.from(
            calculator.querySelectorAll('[data-input=length],[data-input=width]'),
          ),
          field =
            fields.find(function (input) {
              return !Number.isFinite(Number(input.value)) || Number(input.value) <= 0;
            }) || fields[0],
          disclosure = calculator.closest('.e-mobile-tool');
        if (disclosure) disclosure.open = true;
        if (field) {
          field.focus({ preventScroll: true });
          field.scrollIntoView({
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'center',
          });
        }
      } else if (calculatedValid) postItems(calculatedItems);
    });

    const error = document.createElement('p');
    error.className = 'e-bundle-error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    calculated.append(error);
    function sync() {
      const color = selection(root)[1] || root.dataset.color;
      var calc = root.querySelector('.dc-calculator');
      if (calc) {
        var count = calc.querySelector('[data-result="total"]'),
          unit = calc.querySelector('[data-result="unit"]');
        if (count && unit) setText(unit, Number(count.textContent) === 1 ? 'gallon' : 'gallons');
        var nativeCalcText = calc.querySelector('[data-add-to-cart] .btn__text');
        setText(nativeCalcText, 'Add calculated ' + noun + ' to cart');
        var length = Number(calc.querySelector('[data-input="length"]').value),
          width = Number(calc.querySelector('[data-input="width"]').value),
          coats = Number(calc.querySelector('[data-input="coats"]').value),
          needed = length > 0 && width > 0 && coats > 0 ? (length * width * coats) / (Number(root.dataset.eCoverage) || 200) : 0;
        setText(count, String(Math.ceil(needed)));
        setText(unit, Math.ceil(needed) === 1 ? 'gallon' : 'gallons');
        calculatedNeedsDimensions = !Number.isFinite(needed) || needed <= 0;
        var units = (root.dataset.eUnit || '').split('|').map(function (s) {
          return s.trim();
        });
        if (units.length > 1 && units[0]) {
          // systems and kits (P-008): no size option, so count the selected variant, one per calc_coverage sq ft
          var picked = selection(root),
            kit = (data.stains || []).find(function (v) {
              return (v.options || []).every(function (o, i) {
                return !picked[i] || o === picked[i];
              });
            }),
            n = Math.ceil(needed - 1e-9);
          setText(unit, n === 1 ? units[0] : units[1]);
          var kitPlan =
            n > 0 && kit && kit.available
              ? {
                  items: [{ id: kit.id, quantity: n, price: kit.price, compare: kit.compare_at_price || 0 }],
                  cost: kit.price * n,
                }
              : null;
          calculatedItems = kitPlan ? kitPlan.items : [];
          calculatedValid = !!kitPlan;
          var kitRows = kitPlan
            ? '<tr><td>' + String(kit.title).replace(/[&<>"]/g, function (c) {
                return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
              }) + '</td><td>' + n + '</td></tr>'
            : '<tr><td>—</td><td>0</td></tr>';
          var kitBody = calc.querySelector('[data-result="recipe"]');
          if (kitBody && kitBody.innerHTML !== kitRows) kitBody.innerHTML = kitRows;
          calculatedButton.hidden = false;
          calculatedSummary.hidden = false;
          setText(
            calculatedSummary,
            !needed
              ? 'Enter your dimensions to see how many ' + units[1] + ' you need.'
              : !kitPlan
                ? 'This option is currently unavailable.'
                : 'Subtotal ' + money(kitPlan.cost) + '. Shipping and tax calculated at checkout.',
          );
          setText(
            calculatedButton,
            busy
              ? 'Adding to cart…'
              : calculatedValid
                ? 'Add ' + n + ' ' + (n === 1 ? units[0] : units[1]) + ' · ' + money(kitPlan.cost)
                : calculatedNeedsDimensions
                  ? 'Enter project dimensions'
                  : 'Review project dimensions',
          );
          calculatedButton.disabled = busy || (!calculatedValid && !calculatedNeedsDimensions);
          var kitActions = calc.querySelector('[data-cart-actions]');
          if (kitActions && calculated.nextElementSibling !== kitActions) kitActions.before(calculated);
          return;
        }
        var stainOne = (data.stains || []).find(function (v) {
            return /^1 gal/i.test(v.option1 || '') && v.option2 === color;
          }),
          stainFive = (data.stains || []).find(function (v) {
            return /^5 gal/i.test(v.option1 || '') && v.option2 === color;
          });
        var stainPlan = cheapest(needed, stainOne, stainFive),
          sealers = [];
        data.bundles.forEach(function (b) {
          var si = b.options.findIndex(function (o) {
            return /sealer/i.test(o);
          });
          b.variants.forEach(function (v) {
            var name = option(v, si);
            if (sealers.indexOf(name) < 0) sealers.push(name);
          });
        });
        var oneBundle = data.bundles.find(function (b) {
            return b.size === '1 Gallon';
          }),
          fiveBundle = data.bundles.find(function (b) {
            return b.size === '5 Gallons';
          });
        var bundlePlans = sealers
          .map(function (name) {
            var one = oneBundle && variantFor(oneBundle, color, name),
              five = fiveBundle && variantFor(fiveBundle, color, name);
            return {
              name: name,
              plan: cheapest(needed, one, five),
              available: !!((one && one.available) || (five && five.available)),
            };
          })
          .filter(function (p) {
            return p.available;
          });
        var optionsKey =
          color +
          '~' +
          bundlePlans
            .map(function (p) {
              return p.name;
            })
            .join('|');
        if (optionsKey !== calcOptionsKey) {
          calcOptionsKey = optionsKey;
          calcSelect.replaceChildren();
          var placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Select a sealer';
          calcSelect.append(placeholder);
          bundlePlans.forEach(function (p) {
            var o = document.createElement('option');
            o.value = p.name;
            o.textContent = p.name;
            calcSelect.append(o);
          });
          if (
            !bundlePlans.some(function (p) {
              return p.name === calcSealer;
            })
          )
            calcSealer = '';
          calcSelect.value = calcSealer;
        }
        var selectedPlan = bundlePlans.find(function (p) {
            return p.name === calcSealer;
          }),
          lowestBundle = bundlePlans
            .filter(function (p) {
              return p.plan;
            })
            .sort(function (a, b) {
              return a.plan.cost - b.plan.cost;
            })[0];
        var calcOn = calcCheck.checked,
          bundlePlan = selectedPlan && selectedPlan.plan,
          displayPlan = calcOn ? bundlePlan || (lowestBundle && lowestBundle.plan) : stainPlan;
        calc.classList.toggle('e-calc-bundle-on', calcOn);
        calcSealers.hidden = !calcOn;
        calculatedButton.hidden = false;
        calculatedSummary.hidden = false;
        calcCheck.disabled = busy;
        calcSelect.disabled = busy;
        var savingPlan = bundlePlan || (lowestBundle && lowestBundle.plan);
        setText(
          calcSaving,
          savingPlan
            ? 'Save ' + money(savingPlan.saving) + ' total with the bundle'
            : 'Enter dimensions to see total bundle savings',
        );
        calculatedItems = displayPlan ? displayPlan.items : [];
        calculatedValid = !!displayPlan && (!calcOn || !!bundlePlan);
        var tbody = calc.querySelector('[data-result="recipe"]');
        var rows = displayPlan
          ? displayPlan.items
              .map(function (i) {
                return (
                  '<tr><td>' +
                  i.size +
                  ' ' +
                  (i.size === 1 ? 'Gallon' : 'Gallons') +
                  (calcOn ? ' bundle' : '') +
                  '</td><td>' +
                  i.quantity +
                  '</td></tr>'
                );
              })
              .join('')
          : '<tr><td>—</td><td>0</td></tr>';
        if (tbody && tbody.innerHTML !== rows) tbody.innerHTML = rows;
        var explanation = !needed
          ? 'Enter your dimensions to find the lowest-price combination.'
          : !displayPlan
            ? 'No available combination for this color.'
            : (calcOn && !bundlePlan
                ? 'Choose a sealer to confirm this bundle estimate. '
                : 'Lowest-price ' + (calcOn ? 'bundle' : noun) + ' combination. ') +
              (displayPlan.capacity > Math.ceil(needed - 1e-9)
                ? 'Supplies ' +
                  displayPlan.capacity +
                  ' gallons because the larger pack costs less. '
                : '') +
              'Subtotal ' +
              money(displayPlan.cost) +
              '. ' +
              (calcOn
                ? 'Neutralizer and sealer included. Savings vs regular bundle prices. '
                : '') +
              'Shipping and tax calculated at checkout.';
        setText(calculatedSummary, explanation);
        setText(
          calculatedButton,
          busy
            ? 'Adding to cart…'
            : calculatedValid
              ? 'Add calculated ' + (calcOn ? 'bundles' : noun) + ' · ' + money(displayPlan.cost)
              : calculatedNeedsDimensions
                ? 'Enter project dimensions'
                : calcOn
                  ? 'Choose a sealer'
                  : 'Review project dimensions',
        );
        calculatedButton.disabled = busy || (!calculatedValid && !calculatedNeedsDimensions);
        var nativeActions = calc.querySelector('[data-cart-actions]');
        if (nativeActions && calculated.nextElementSibling !== nativeActions)
          nativeActions.before(calculated);
      }
    }
    async function postItems(items) {
      if (busy) return;
      busy = true;
      error.hidden = true;
      sync();
      try {
        await addItems(data, items);
      } catch (e) {
        busy = false;
        setText(error, e.message);
        error.hidden = false;
        sync();
        error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    const media = matchMedia('(max-width:767px)');
    function arrange() {
      const plan = root.querySelector('.e-plan');
      if (media.matches) {
        [
          ['.e-calculator-panel', 'Calculate how much you need', 'calculator'],
          ['.e-guide-panel', 'Preparation & application guide', 'guide'],
        ].forEach(([selector, title, kind]) => {
          const panel = plan.querySelector(selector);
          if (!panel || panel.closest('.e-mobile-tool')) return;
          const wrap = document.createElement('details');
          wrap.className = 'e-mobile-tool e-mobile-tool--' + kind;
          const summary = document.createElement('summary');
          summary.textContent = title;
          panel.before(wrap);
          wrap.append(summary, panel);
        });
      } else {
        plan.querySelectorAll('.e-mobile-tool').forEach((wrap) => {
          wrap.before(wrap.querySelector('.e-calculator-panel,.e-guide-panel'));
          wrap.remove();
        });
      }
    }
    scope.on(media, 'change', arrange);
    arrange();
    scope.on(root, 'input', sync);
    scope.on(root, 'change', sync);
    scope.on(document, 'dc:pdp-selection', sync);
    scope.on(document, 'change', (e) => {
      if (e.target.closest('[data-dc-pdp]')) scope.frame(sync);
    });
    root.querySelectorAll('.product__block--collapsible_tab details').forEach(function (detail) {
      var summaryTpl = root.querySelector('template[data-e-details-summary]');
      if (!summaryTpl || detail.querySelector('summary p')?.textContent.trim() !== (summaryTpl.dataset.tab || 'Product Details')) return;
      var content = detail.querySelector('.accordion-details__content');
      if (!content) return;
      var full = document.createElement('details');
      full.className = 'e-full-info';
      full.innerHTML = '<summary>Full product information</summary><div></div>';
      while (content.firstChild) full.lastElementChild.append(content.firstChild);
      content.innerHTML = summaryTpl.innerHTML;
      content.append(full);
    });

    root.querySelectorAll('.accordion-details__summary').forEach((summary) => {
      const descriptions = {
        'Product Details': 'Benefits, coverage and application essentials',
        Specifications: 'Technical information at a glance',
        'Reaction Times': 'Color-specific timing before neutralizing',
      };
      const title = summary.querySelector('p');
      if (title && descriptions[title.textContent.trim()]) {
        const caption = document.createElement('span');
        caption.className = 'e-accordion-caption';
        caption.textContent = descriptions[title.textContent.trim()];
        title.parentElement.append(caption);
      }
    });
    mountCompactTools(root, scope);
    scope.updates.add(sync);
    sync();
  }

  function mountGallery(root, scope) {
    const sectionId = root.dataset.section;
    root.classList.add('e-p');
    var source = root.querySelector('[data-e-source]');
    if (!source || source.dataset.mounted) return;
    var gallery = root.querySelector('media-gallery'),
      info = root.querySelector('[id^="ProductInfo-"] .product__blocks');
    if (!gallery || !info) return;
    var dataNode = gallery.querySelector('[data-variant-showcase-data]'),
      lookupNode = gallery.querySelector('[data-variant-showcase-lookup]'),
      c = cfg(root);
    var data, lookup;
    try {
      if (dataNode && lookupNode) {
        data = JSON.parse(dataNode.textContent);
        lookup = JSON.parse(lookupNode.textContent);
      } else {
        data = {};
        data[gallery.dataset.selectedVariant] = JSON.parse(source.querySelector('[data-e-photos]').textContent);
        lookup = {};
      }
    } catch (e) {
      return;
    }
    source.dataset.mounted = 'true';
    var ssr = root.classList.contains('e-ssr'),
      from = ssr ? root : source;
    var ui = from.querySelector('.e-gallery'),
      confidence = from.querySelector('.e-confidence'),
      shipping = from.querySelector('.e-shipping'),
      intro = (ssr && root.querySelector('.e-desktop-support .e-intro')) || from.querySelector('.e-intro'),
      dialog = from.querySelector('dialog.e-dialog');
    if (!ssr) {
      gallery.before(ui);
      [intro, confidence, shipping, dialog].forEach(function (el) {
        if (el) info.append(el);
      });
    }
    var panel = from.querySelector('.e-panel'),
      videoDialog = from.querySelector('.e-video-dialog');
    if (!ssr) {
      if (panel) info.append(panel);
      if (videoDialog) info.append(videoDialog);
    }
    if (panel && videoDialog) {
      var videoButton = panel.querySelector('[data-e-video]'), frame = videoDialog.querySelector('.e-video-frame');
      scope.on(videoButton, 'click', function () {
        var f = document.createElement('iframe');
        f.src = videoButton.dataset.eVideo; f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen = true;
        f.title = videoDialog.getAttribute('aria-label') || 'Video';
        frame.replaceChildren(f);
        videoDialog.showModal();
      });
      scope.on(videoDialog.querySelector('[data-e-video-close]'), 'click', function () { videoDialog.close(); });
      scope.on(videoDialog, 'click', function (e) { if (e.target === videoDialog) videoDialog.close(); });
      scope.on(videoDialog, 'close', function () { frame.replaceChildren(); });
    }
    var installments = root.querySelector('form.installment');
    if (installments) {
      installments.classList.add('e-installments');
      if (!ssr) info.insertBefore(installments, shipping);
    }
    var host = source.closest('.product__block');
    if (host) host.style.display = 'none';
    var layout = root.querySelector('.product');
    var help = root.querySelector('.product__block--request_callback');
    if (help && !ssr) info.insertBefore(help, shipping);
    var pickerBlock = root.querySelector('.product__block--variant_picker');
    var jump = ssr ? root.querySelector('.e-calculator-jump') : document.createElement('a');
    if (!ssr) {
      jump.className = 'e-calculator-jump';
      jump.href = '#e-project-calculator-' + sectionId;
      jump.textContent = c.calculator || '';
      if (c.calculator && related(root, 'tools')) info.append(jump);
    } else if (jump && !related(root, 'tools')) {
      jump.remove();
      jump = null;
    }
    if (jump) scope.on(jump, 'click', function (e) {
      e.preventDefault();
      var tools = related(root, 'tools');
      var target = tools && tools.querySelector('.e-calculator-panel');
      if (!target) return;
      tools.dispatchEvent(new CustomEvent('dc:calculator-open'));
      var expandable = target.closest('.e-mobile-tool');
      if (expandable) expandable.open = true;
      target.focus({ preventScroll: true });
      target.scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start',
      });
    });
    var onDetails = function () {
      var detail = Array.from(
        (related(root, 'tools') || root).querySelectorAll(
          '.product__block--collapsible_tab details',
        ),
      ).find(function (el) {
        return (
          el.offsetWidth > 0 &&
          el.querySelector('summary p') &&
          el.querySelector('summary p').textContent.trim() === (c.detailsTab || 'Product Details')
        );
      });
      if (!detail) {
        var tab = Array.from(document.querySelectorAll('.tabs__nav [role="tab"]')).find(function (b) {
          return b.textContent.trim() === (c.detailsTab || 'Product Details');
        });
        if (tab) {
          tab.click();
          (tab.closest('.shopify-section') || tab).scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          tab.focus({ preventScroll: true });
        }
      }
      if (detail) {
        var summary = detail.querySelector('summary');
        if (!detail.open) summary.click();
        summary.focus({ preventScroll: true });
        detail.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
      }
    };
    root.querySelectorAll('[data-e-product-details]').forEach(function (b) {
      scope.on(b, 'click', onDetails);
    });
    var desktop = matchMedia('(min-width:768px)'),
      support = ssr ? root.querySelector('.e-desktop-support') : document.createElement('div');
    if (!ssr) {
      support.className = 'e-desktop-support';
      ui.after(support);
    }
    var trust = document.createElement('p');
    trust.className = 'e-trust';
    trust.textContent = c.trust || '';
    function placeSupport() {
      var target = desktop.matches ? support : info;
      target.append(intro);
      if (help) target.append(help);
      if (c.trust) target.append(trust);
    }
    if (!ssr) {
      placeSupport();
      scope.on(desktop, 'change', placeSupport);
    }
    var coachSubtitle = help && help.querySelector('.rcb__subtitle'),
      coachOriginal = coachSubtitle && coachSubtitle.textContent;
    function arrangeMobileTools() {
      if (help) {
        help.classList.toggle('e-mobile-coach', !desktop.matches);
        if (ssr) {
          var buying = root.querySelector('.e-mobile-buying');
          if (!desktop.matches && buying) buying.insertBefore(help, buying.querySelector('.e-panel'));
          else if (desktop.matches && support) support.insertBefore(help, support.querySelector('.e-trust'));
        } else if (!desktop.matches) info.append(help);
        if (coachSubtitle && c.coachMobile)
          coachSubtitle.textContent = desktop.matches
            ? coachOriginal
            : c.coachMobile;
      }
    }
    arrangeMobileTools();
    scope.on(desktop, 'change', arrangeMobileTools);
    var colors = c.colors || [];
    var gallerySlugs = {
      Blackish: 'black',
      Avocado: 'avocado',
      'Azure Blue': 'azure-blue',
      'Coffee Brown': 'coffee-brown',
      Cola: 'cola',
      'Desert Amber': 'desert-amber',
      'English Red': 'english-red',
      'Malayan Buff': 'malayan-buff',
      Seagrass: 'seagrass',
      'Shifting Sand': 'shifting-sand',
    };
    var currentKey = null,
      photos = [],
      photoIndex = 0,
      currentColor = '',
      currentSize = '',
      queued = false,
      packshotRe = null;
    function imgUrl(u, w) {
      var url = new URL(u, location.href);
      url.searchParams.set('width', String(w));
      return url.href;
    }
    function bottle(p) {
      var re = packshotRe || (packshotRe = new RegExp(c.packshot || 'gallon|ounce|bottle|pail|jug|_1_Gallon|_5_Gallon|_4_Ounce', 'i'));
      return re.test(p.a || '') || re.test(p.u || '');
    }
    // the colours a photo shows, from its alt, as names without codes ("503 Black" is Black): whole words, longer
    // names first so "Light Charcoal" isn't also Charcoal; the current colour first (P-008, AcquaTint). Same as
    // snippets/dc-pdp-color-names.
    function cname(v) {
      var w = String(v || '').split(' ');
      return w.length > 1 && Number(w[0]) > 0 ? w.slice(1).join(' ') : String(v || '');
    }
    function recipe(p) {
      var hay = ' ' + String(p.a || '').toLowerCase().replace(/[,.™®();:\-\/&'’]/g, ' ') + ' ',
        hit = {};
      [2, 1].forEach(function (pass) {
        colors.forEach(function (v) {
          var n = cname(v), multi = n.split(' ').length > 1;
          if ((pass === 2) !== multi) return;
          var needle = ' ' + n.toLowerCase() + ' ';
          if (hay.indexOf(needle) >= 0) {
            hit[v] = true;
            hay = hay.split(needle).join(' ¦ ');
          }
        });
      });
      return colors
        .filter(function (v) { return hit[v]; })
        .sort(function (a, b) {
          return (a === currentColor ? -1 : 0) - (b === currentColor ? -1 : 0);
        })
        .map(cname);
    }
    // P-008: the products and colours a project photo was made with, read from its file name
    // (DC-WAX-HGL-PROJ-CAS-COB-SOL-HGL-1 → "EverStain Coffee Brown · EasySeal Gloss · ProWax Polish Gloss"): the codes
    // after -PROJ- in the order the floor was built, then the page's own product. A colour code belongs to the product
    // before it (photo_colors: CAS:COB|Coffee Brown); a finish code is added to it. Names never break inside.
    function madeWith(p) {
      var prod = c.photoRecipe || {}, cols = c.photoColors || {}, fin = {}, toks = c.photoTokens || {};
      Object.keys(toks).forEach(function (k) { fin[toks[k]] = k; });
      if (!Object.keys(prod).length || bottle(p)) return '';
      var parts = String(p.u || '').split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '').toUpperCase().split('-'),
        at = parts.indexOf('PROJ');
      if (at < 0) return '';
      var nb = function (x) { return x.replace(/ /g, '\u00a0'); }, groups = [], g = null;
      parts.slice(at + 1).concat(parts.slice(0, at)).forEach(function (t) {
        if (prod[t]) { g = { code: t, name: prod[t], cols: [], fin: '' }; groups.push(g); }
        else if (g && fin[t] && !g.fin) g.fin = fin[t];
        else if (g && cols[g.code + ':' + t] && g.cols.indexOf(cols[g.code + ':' + t]) < 0) g.cols.push(cols[g.code + ':' + t]);
      });
      return groups.map(function (x) {
        return nb(x.name) + (x.cols.length ? '\u00a0' + x.cols.map(nb).join(', ') : '') + (x.fin ? '\u00a0' + x.fin : '');
      }).filter(function (x, i, all) { return all.indexOf(x) === i; }).join(' · ');
    }
    function showPhoto(i) {
      if (!photos.length) return;
      photoIndex = (i + photos.length) % photos.length;
      var p = photos[photoIndex],
        image = ui.querySelector('[data-e-hero]'),
        names = recipe(p);
      image.src = imgUrl(p.u, 1200);
      image.srcset = [480, 720, 1000, 1400]
        .map(function (w) {
          return imgUrl(p.u, w) + ' ' + w + 'w';
        })
        .join(',');
      image.sizes = '(max-width:767px) calc(100vw - 32px), 52vw';
      image.alt = p.a || c.title || '';
      image.style.objectFit = bottle(p) || p.f === 'contain' ? 'contain' : 'cover';
      var cmpFrame = ui.querySelector('[data-e-enlarge]'), cmp = cmpFrame.querySelector('.e-compare');
      if (p.t === 'compare') {
        if (!cmp) {
          cmp = document.createElement('span'); cmp.className = 'e-compare'; cmp.setAttribute('aria-hidden', 'true');
          cmp.innerHTML = '<span class="e-compare-a"><b></b></span><span class="e-compare-b"><b></b></span>';
          cmpFrame.prepend(cmp);
        }
        cmp.style.setProperty('--e-cmp', 'url("' + imgUrl(p.u, 1600) + '")');
        cmp.style.setProperty('--e-split', String(p.s || 49));
        cmp.style.setProperty('--e-focus', (p.x == null ? 50 : p.x) + '%');
        cmp.querySelector('.e-compare-a b').textContent = p.lb || '';
        cmp.querySelector('.e-compare-b b').textContent = p.la || '';
        cmp.classList.toggle('is-stacked', p.m === 'stacked');
        cmp.style.setProperty('--e-ar', String(p.ar || 1));
        cmp.hidden = false;
      } else if (cmp) cmp.hidden = true;
      cmpFrame.classList.toggle('is-compare', p.t === 'compare');
      var frameEl = ui.querySelector('[data-e-enlarge]');
      frameEl.classList.toggle('is-whole', !bottle(p) && p.f === 'contain');
      frameEl.classList.toggle('is-fill', bottle(p) && c.packshotFill === 'blur');
      frameEl.style.setProperty('--e-photo-fill', (p.f === 'contain' && !bottle(p)) || (bottle(p) && c.packshotFill === 'blur') ? 'url("' + imgUrl(p.u, 600) + '")' : 'none');
      ui.querySelector('[data-e-enlarge]').classList.toggle('is-packshot', bottle(p));
      ui.querySelector('[data-e-caption]').textContent = bottle(p)
        ? [currentSize, cname(currentColor)].filter(Boolean).join(' · ')
        : madeWith(p)
          ? madeWith(p)
          : names.length
          ? names.join(' + ')
          : p.f === 'contain'
            ? ''
            : cname(currentColor);
      ui.querySelector('[data-e-kind]').textContent = bottle(p)
        ? c.kindPackshot || ''
        : names.length > 1
          ? 'Color blend'
          : c.kindPhoto || '';
      ui.querySelectorAll('[data-e-photo-index]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.dataset.ePhotoIndex) === photoIndex));
      });
      if (dialog.open) updateDialog();
    }
    function updateDialog() {
      var p = photos[photoIndex];
      if (!p) return;
      dialog.querySelector('[data-e-dialog-img]').src = imgUrl(p.u, 1600);
      dialog.querySelector('[data-e-dialog-img]').alt = p.a;
      dialog.querySelector('[data-e-dialog-caption]').textContent = p.a;
      dialog.querySelector('[data-e-dialog-title]').textContent = bottle(p)
        ? [currentSize, cname(currentColor)].filter(Boolean).join(' · ') || c.title
        : madeWith(p) || recipe(p).join(' + ') || cname(currentColor);
    }
    function openPhoto(i) {
      showPhoto(i);
      updateDialog();
      if (!dialog.open) dialog.showModal();
    }
    function thumb(p, i, small) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', (small ? 'Enlarge: ' : 'View: ') + p.a);
      var im = document.createElement('img');
      im.src = imgUrl(p.u, small ? 360 : 180);
      im.alt = p.a;
      im.width = 240;
      im.height = 180;
      im.loading = 'lazy';
      b.append(im);
      if (small) {
        scope.on(b, 'click', function () {
          openPhoto(i);
        });
      } else {
        b.className = 'e-thumb';
        b.dataset.ePhotoIndex = i;
        b.setAttribute('aria-pressed', 'false');
        scope.on(b, 'click', function () {
          showPhoto(i);
        });
      }
      return b;
    }
    function sync() {
      queued = false;
      if (!root.isConnected) return;
      var picker = root.querySelector('variant-selects'),
        selected = picker
          ? Array.from(picker.querySelectorAll('fieldset')).map(function (f) {
              var el = f.querySelector('input:checked');
              return el ? el.value : '';
            })
          : [];
      var key = selected.join('~'),
        id = lookup[key] || gallery.dataset.selectedVariant,
        list = data[id];
      if (!list || !list.length) return;
      currentSize = c.sizeIndex >= 0 ? selected[c.sizeIndex] || '' : '';
      currentColor = c.colorIndex >= 0 ? selected[c.colorIndex] || '' : '';
      var price = root.querySelector('.product__block--price'),
        summary = price && price.querySelector('.e-selection');
      var rule = (c.coverage || []).find(function (r) {
        return r[0] === '*' || currentSize.indexOf(r[0]) === 0;
      });
      var coverage = rule ? rule[1] : '';
      if (summary && !coverage) summary.remove();
      if (price && !summary && coverage) {
        summary = document.createElement('div');
        summary.className = 'e-selection e-ui';
        summary.setAttribute('aria-live', 'polite');
        price.append(summary);
      }
      if (summary && summary.isConnected) {
        var text = coverage;
        if (summary.textContent !== text) summary.textContent = text;
      }
      if (key === currentKey) return;
      currentKey = key;
      photos = list
        .map(function (p, i) {
          return Object.assign({ original: i }, p);
        })
        .sort(function (a, b) {
          var score = function (p) {
            return bottle(p)
              ? (c.packshotFirst ? -1 : 100)
              : recipe(p).length > 1 && !c.keepOrder   // photo_keep_order: photos naming two colours keep their place (P-028)
                ? 10
                : 0;
          };
          return score(a) - score(b) || a.original - b.original;
        });
      var toks = c.photoTokens || {}, tokList = Object.keys(toks).map(function (k) { return '-' + toks[k] + '-'; });
      if (tokList.length) {   // P-008: a photo carrying another value's -TOKEN- in its file name is left out
        var mine = toks[currentColor] ? '-' + toks[currentColor] + '-' : '';
        photos = photos.filter(function (p) {
          if (bottle(p) || p.t === 'compare' || p.t === 'extra') return true;
          var fn = String(p.u || '').split('?')[0].split('/').pop().toUpperCase();
          var tagged = tokList.some(function (t) { return fn.indexOf(t) >= 0; });
          return !tagged || (mine && fn.indexOf(mine) >= 0);
        });
      }
      var skip = (c.photoSkip || []).map(function (w) { return String(w).trim(); }).filter(Boolean);
      if (skip.length) photos = photos.filter(function (p) {   // P-008: leave out project photos whose alt has one of these words
        if (bottle(p) || p.t === 'compare' || p.t === 'extra') return true;
        var al = String(p.a || '').toLowerCase();
        return !skip.some(function (w) { return al.indexOf(w) >= 0; });
      });
      if (c.photoLimit > 0) {
        var own = function (p) { return !bottle(p) && p.t !== 'compare' && p.f !== 'contain'; };
        var allowed = photos.filter(own).map(function (p) { return p.original; }).sort(function (a, b) { return a - b; }).slice(0, c.photoLimit);
        photos = photos.filter(function (p) { return !own(p) || allowed.indexOf(p.original) >= 0; });
      }
      var chosenMedia = c.perVariant && (c.variantMedia || {})[key];
      var chosenFile = c.perVariant && (c.variantFile || {})[key];
      var fileOf = function (u) { return String(u || '').split('?')[0].split('/').pop(); };
      if (chosenMedia) photos = photos.filter(function (p) {   // only the chosen size and finish; showcase photos carry no media id, so match by file name
        return !bottle(p) || p.mid === chosenMedia || (p.mid == null && chosenFile && fileOf(p.u) === chosenFile);
      });
      var thumbs = ui.querySelector('[data-e-thumbs]');
      thumbs.replaceChildren();
      photos.forEach(function (p, i) {
        thumbs.append(thumb(p, i, false));
      });
      root.dispatchEvent(new CustomEvent('dc:pdp-selection', { bubbles: true }));
      showPhoto(0);
      ui.hidden = false;
      gallery.hidden = true;
      gallery.style.display = 'none';
      root.classList.add('e-ready');
    }
    function schedule() {
      if (!queued) {
        queued = true;
        scope.frame(sync);
      }
    }
    scope.on(ui.querySelector('[data-e-enlarge]'), 'click', function () {
      openPhoto(photoIndex);
    });
    var chooseButton = ui.querySelector('[data-e-choose]');
    if (chooseButton) scope.on(chooseButton, 'click', function () {
      var picker = root.querySelector('.product__block--variant_picker');
      if (picker) {
        picker.setAttribute('tabindex', '-1');
        picker.focus({ preventScroll: true });
        picker.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
      }
    });
    scope.on(dialog.querySelector('[data-e-close]'), 'click', function () {
      dialog.close();
    });
    scope.on(dialog.querySelector('[data-e-prev]'), 'click', function () {
      showPhoto(photoIndex - 1);
    });
    scope.on(dialog.querySelector('[data-e-next]'), 'click', function () {
      showPhoto(photoIndex + 1);
    });
    scope.on(dialog, 'keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        showPhoto(photoIndex + 1);
      }
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        showPhoto(photoIndex - 1);
      }
    });
    scope.on(dialog, 'click', function (e) {
      if (e.target === dialog) {
        var r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)
          dialog.close();
      }
    });
    scope.on(root, 'change', schedule);
    scope.updates.add(schedule);
    sync();
  }
  function mountCommerce(root, scope) {
    const sectionId = root.dataset.section;
    root.classList.add('e-p');
    var bc = cfg(root),   // P-008: the bundle's words and choice option are settings; blanks keep acid's
      choiceRe = new RegExp(bc.bundleOption || 'sealer', 'i'),
      word = bc.bundleWord || 'sealer',
      notes = String(bc.bundleNotes || '').split('\n').map(function (l) { return l.split('|'); }).filter(function (p) { return p.length > 1 && p[0].trim(); });
    var source = root.querySelector('[data-e-bundle-source]');
    if (!source || source.dataset.mounted) return;
    var data;
    try {
      data = JSON.parse(source.querySelector('[data-e-bundle-catalog]').textContent);
    } catch (e) {
      return;
    }
    var info = root.querySelector('[id^="ProductInfo-"] .product__blocks'),
      buy = root.querySelector('.product__block--buy_buttons');
    if (!info || !buy) return;
    source.dataset.mounted = 'true';
    var box = (root.classList.contains('e-ssr') ? root : source).querySelector('[data-e-bundle]');
    var buyingWrap = root.classList.contains('e-ssr') && root.querySelector('.e-mobile-buying');
    if (buyingWrap) buyingWrap.insertBefore(box, buy);
    else info.append(box);
    var host = source.closest('.product__block');
    if (host) host.style.display = 'none';
    var check = box.querySelector('[data-e-bundle-check]'),
      body = box.querySelector('[data-e-bundle-body]'),
      choices = box.querySelector('[data-e-bundle-choices]'),
      error = box.querySelector('[data-e-bundle-error]');
    var selectedSealer = '',
      catalogKey = '',
      activeBundle = null,
      activeVariant = null,
      busy = false,
      queued = false;
    var currency = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: data.currency || 'USD',
    });
    function money(cents) {
      return currency.format(cents / 100);
    }
    function setText(el, value) {
      if (el && el.textContent !== value) el.textContent = value;
    }
    function option(v, index) {
      return index >= 0 ? (v.options || [])[index] : '';
    }
    function current() {
      var fs = root.querySelectorAll('variant-selects fieldset');
      return Array.from(fs).map(function (f) {
        var input = f.querySelector('input:checked');
        return input ? input.value : '';
      });
    }
    function quantity() {
      var input = root.querySelector('form.main-product-form input[name="quantity"]');
      return Math.max(1, Math.floor(Number(input && input.value) || 1));
    }
    function variantFor(bundle, color, sealer) {
      var ci = bundle.options.findIndex(function (o) {
          return /color/i.test(o);
        }),
        si = bundle.options.findIndex(function (o) {
          return choiceRe.test(o);
        });
      return bundle.variants.find(function (v) {
        return option(v, ci) === color && option(v, si) === sealer;
      });
    }
    function showError(message) {
      setText(error, message);
      error.hidden = !message;
    }
    function buildChoices(bundle, color) {
      choices.replaceChildren();
      var si = bundle.options.findIndex(function (o) {
          return choiceRe.test(o);
        }),
        ci = bundle.options.findIndex(function (o) {
          return /color/i.test(o);
        });
      bundle.variants
        .filter(function (v) {
          return option(v, ci) === color;
        })
        .sort(function (a, b) {
          return Number(b.available) - Number(a.available);
        })
        .forEach(function (v, i) {
          var sealer = option(v, si),
            label = document.createElement('label');
          label.className = 'e-bundle-choice';
          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'e-bundle-sealer-' + sectionId;
          input.value = sealer;
          input.disabled = !v.available;
          input.checked = v.available && sealer === selectedSealer;
          var text = document.createElement('span'),
            name = document.createElement('strong'),
            kind = document.createElement('small'),
            price = document.createElement('em');
          name.textContent = sealer;
          var note = notes.find(function (p) { return sealer.toLowerCase().indexOf(p[0].trim().toLowerCase()) >= 0; });
          kind.textContent = note ? note.slice(1).join('|').trim() : /easyseal/i.test(sealer) ? 'Solvent-based' : 'Water-based';
          price.textContent = v.available ? money(v.price) + ' bundle' : 'Currently unavailable';
          text.append(name, kind, price);
          label.append(input, text);
          choices.appendChild(label);
        });
    }
    function ensureButton() {
      var native = root.querySelector('button[id^="ProductSubmitButton-"]');
      if (!native) return null;
      var button = root.querySelector('.e-bundle-purchase');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = native.className + ' e-bundle-purchase';
        button.dataset.eBundlePurchase = '';
        button.hidden = true;
        scope.on(button, 'click', addBundle);
        native.after(button);
      }
      return button;
    }

    function sync() {
      queued = false;
      if (!root.isConnected) return;
      var values = current(),
        size = values[0],
        color = values[1];
      activeBundle = data.bundles.find(function (b) {
        return (
          b.size === size &&
          Array.isArray(b.variants) &&
          b.variants.length &&
          Array.isArray(b.options)
        );
      });
      var key = size + '~' + color;
      if (!activeBundle) {
        check.checked = false;
        selectedSealer = '';
        catalogKey = '';
        activeVariant = null;
        box.hidden = true;
      } else {
        var candidates = activeBundle.variants.filter(function (v) {
          var ci = activeBundle.options.findIndex(function (o) {
            return /color/i.test(o);
          });
          return option(v, ci) === color && v.available;
        });
        box.hidden = !candidates.length;
        if (box.hidden) check.checked = false;
        if (key !== catalogKey) {
          var preserved = variantFor(activeBundle, color, selectedSealer);
          if (!preserved || !preserved.available) selectedSealer = '';
          buildChoices(activeBundle, color);
          catalogKey = key;
          showError('');
        }
        activeVariant = variantFor(activeBundle, color, selectedSealer) || null;
        if (activeVariant && !activeVariant.available) activeVariant = null;
        var savings = candidates.map(function (v) {
            return Math.max(0, (v.compare_at_price || 0) - v.price);
          }),
          maxSave = Math.max.apply(null, [0].concat(savings)),
          minSave = Math.min.apply(null, savings);
        var offerSaving = activeVariant
          ? Math.max(0, (activeVariant.compare_at_price || 0) - activeVariant.price)
          : maxSave;
        setText(
          box.querySelector('[data-e-bundle-offer]'),
          offerSaving
            ? 'Save ' + (!activeVariant && minSave !== maxSave ? 'up to ' : '') + money(offerSaving)
            : 'Complete your project',
        );
        var prices = candidates.map(function (v) {
            return v.price;
          }),
          minPrice = Math.min.apply(null, prices),
          maxPrice = Math.max.apply(null, prices);
        setText(
          box.querySelector('[data-e-bundle-upgrade]'),
          activeVariant
            ? 'Complete bundle ' + money(activeVariant.price)
            : candidates.length
              ? 'Complete bundle ' + (minPrice !== maxPrice ? 'from ' : '') + money(minPrice)
              : '',
        );
        setText(
          box.querySelector('[data-e-bundle-includes]'),
          (bc.bundleIncludes || '{size} {name} in {color} + ProClean Neutralizer + {choice}. Matched quantities for the {area} sq ft bundle.')
            .split('{size}').join(size)
            .split('{name}').join(bc.bundleName || '')
            .split('{color}').join(color)
            .split('{choice}').join(activeVariant ? selectedSealer : bc.bundleChoiceBlank || 'your choice of sealer')
            .split('{area}').join(size === bc.bundleSmallSize ? bc.bundleSmallArea : bc.bundleLargeArea)
            .replace(/ {2,}/g, ' '),
        );
        var qty = quantity();
        box.querySelector('[data-e-bundle-totals]').hidden = !activeVariant;
        if (activeVariant) {
          setText(
            box.querySelector('[data-e-bundle-total-label]'),
            qty === 1 ? 'Bundle total' : qty + ' bundles total',
          );
          setText(box.querySelector('[data-e-bundle-total]'), money(activeVariant.price * qty));
          var saved =
            Math.max(0, (activeVariant.compare_at_price || 0) - activeVariant.price) * qty;
          setText(
            box.querySelector('[data-e-bundle-savings]'),
            saved ? 'You save ' + money(saved) : '',
          );
          box.querySelector('[data-e-bundle-savings]').hidden = !saved;
        }
        var details = box.querySelector('[data-e-bundle-details]');
        details.setAttribute(
          'href',
          activeBundle.url + (activeVariant ? '?variant=' + activeVariant.id : ''),
        );
      }
      var on = check.checked && !box.hidden;
      body.hidden = !on;
      check.setAttribute('aria-expanded', String(on));
      root.classList.toggle('e-bundle-on', on);
      check.disabled = busy;
      var button = ensureButton();
      if (button) {
        button.hidden = !on;
        button.disabled = busy;
        setText(
          button,
          busy
            ? 'Adding bundle…'
            : activeVariant
              ? 'Add bundle to cart · ' + money(activeVariant.price * quantity())
              : 'Choose a ' + word,
        );
      }
      var price = root.querySelector('.product__block--price');
      if (price) {
        var label = price.querySelector('.e-bundle-stain-label');
        if (on && !label) {
          label = document.createElement('span');
          label.className = 'e-bundle-stain-label';
          price.prepend(label);
        }
        if (label) {
          label.hidden = !on;
          setText(label, bc.bundleBase || 'STAIN ONLY');
        }
      }
      var sticky = document.querySelector(
        'sticky-atc-bar-minimalist[data-section="' + sectionId + '"]',
      );
      if (sticky) {
        sticky.style.display = on ? 'none' : '';
      }
    }
    function schedule() {
      if (!queued) {
        queued = true;
        scope.frame(sync);
      }
    }
    function addBundle() {
      if (busy) return;
      sync();
      if (!check.checked || box.hidden) return;
      if (!activeVariant) {
        showError('Choose a ' + word + ' to complete your bundle.');
        var first = choices.querySelector('input:not(:disabled)');
        if (first) first.focus();
        return;
      }
      postItems([{ id: activeVariant.id, quantity: quantity() }]);
    }
    function postItems(items) {
      if (busy) return;
      busy = true;
      showError('');
      sync();
      fetch(data.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: items.map(function (item) {
            return { id: item.id, quantity: item.quantity };
          }),
        }),
      })
        .then(function (response) {
          return response.json().then(function (result) {
            if (!response.ok)
              throw new Error(
                result.description ||
                  'This bundle could not be added. Please review your selection.',
              );
            return result;
          });
        })
        .then(function () {
          window.location.assign(data.cartUrl);
        })
        .catch(function (err) {
          busy = false;
          sync();
          showError(
            err.message === 'Failed to fetch'
              ? 'We could not confirm the cart update. Check your cart before trying again.'
              : err.message,
          );
          box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }
    scope.on(check, 'change', function () {
      showError('');
      sync();
      // the add-on checkbox ("Add ProWax Polish™" on AcquaTint™, the sealer bundle on acid): one event a toggle, to GTM's
      // dataLayer, GA4 through the page's own gtag (no Tag Manager access) and Clarity (P-028, Pablo 2026-11-02)
      try {
        var addon = box.querySelector('.e-bundle-heading strong');
        var ev = { addon: addon ? addon.textContent.trim() : '', checked: check.checked, product: location.pathname.split('/products/')[1] || '', page: location.pathname };
        (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'dc_addon_toggle' }, ev));
        if (typeof window.gtag === 'function') window.gtag('event', 'dc_addon_toggle', Object.assign({ send_to: 'G-EBEE92KHR1' }, ev));
        if (typeof window.clarity === 'function') window.clarity('event', check.checked ? 'dc_addon_on' : 'dc_addon_off');
      } catch (err) {}
    });
    scope.on(choices, 'change', function (e) {
      if (e.target.type === 'radio') {
        selectedSealer = e.target.value;
        showError('');
        sync();
      }
    });
    scope.on(window, 'pageshow', function () {
      scope.frame(function () {
        if (!root.isConnected) return;
        var selected = choices.querySelector('input:checked:not(:disabled)');
        if (selected) selectedSealer = selected.value;
        sync();
      });
    });
    scope.on(root, 'change', schedule);
    scope.on(root, 'input', function (e) {
      if (e.target.name === 'quantity' || e.target.matches('.dc-calculator input')) schedule();
    });
    scope.on(
      root,
      'submit',
      function (e) {
        if (check.checked && e.target.matches('form.main-product-form')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          addBundle();
        }
      },
      true,
    );
    scope.updates.add(schedule);
    sync();
  }
  function mountPresentation(root, scope) {
    var gallery = root.querySelector('.e-gallery'),
      layout = root.querySelector('.product'),
      wrapper = document.createElement('div');
    wrapper.className = 'e-mobile-buying';
    var options = document.createElement('div');
    options.className = 'e-mobile-options';
    var selectors = [
      '.e-benefit',
      '.product__block--variant_picker',
      '.e-confidence',
      '.e-bundle',
      '.product__block--buy_buttons',
      '.e-calculator-jump',
      '.product__block--request_callback',
      '.e-panel',
    ];
    var entries = selectors
        .map(function (s) {
          var node = root.querySelector(s);
          if (!node) return null;
          var anchor = document.createComment('mobile buying position');
          node.before(anchor);
          return { node: node, anchor: anchor };
        })
        .filter(Boolean),
      media = matchMedia('(max-width:767px)');
    function arrange() {
      if (media.matches) {
        layout.append(wrapper);
        wrapper.prepend(options);
        entries.forEach(function (entry, index) {
          (index < 3 ? options : wrapper).append(entry.node);
        });
      } else {
        entries.forEach(function (entry) {
          if (wrapper.contains(entry.node)) entry.anchor.after(entry.node);
        });
        wrapper.remove();
      }
    }
    arrange();
    scope.on(media, 'change', arrange);
  }
  function mountCompactTools(root, scope) {
    var desktop = matchMedia('(min-width:768px)');
    root.querySelectorAll('.e-calculator-panel,.e-guide-panel').forEach(function (panel) {
      var calculator = panel.classList.contains('e-calculator-panel'),
        toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'e-desktop-tool-toggle';
      if (!panel.id) panel.id = 'e-preparation-' + root.dataset.section;
      toggle.setAttribute('aria-controls', panel.id);
      function state(compact) {
        panel.classList.toggle('e-tool-compact', compact);
        toggle.setAttribute('aria-expanded', String(!compact));
        toggle.textContent = compact
          ? calculator
            ? 'Show estimate & quantities'
            : 'View preparation steps'
          : calculator
            ? 'Collapse calculator'
            : 'Collapse preparation guide';
      }
      panel.append(toggle);
      state(true);
      scope.on(toggle, 'click', function () {
        var closing = !panel.classList.contains('e-tool-compact');
        state(closing);
        if (closing) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          panel.setAttribute('tabindex', '-1');
          panel.focus({ preventScroll: true });
        }
      });
      if (calculator) scope.on(root, 'dc:calculator-open', () => state(false));
    });
  }
  function mount() {
    instances.forEach((scope, root) => {
      if (!root.isConnected) {
        scope.destroy();
        instances.delete(root);
      }
    });
    document
      .querySelectorAll(
        '[data-dc-pdp],[data-dc-pdp-part="banner"],[data-dc-pdp-part="tools"]',
      )
      .forEach((root) => {
        if (instances.has(root)) {
          instances.get(root).updates.forEach((update) => update());
          return;
        }
        const scope = createScope();
        instances.set(root, scope);
        if (root.hasAttribute('data-dc-pdp')) {
          mountGallery(root, scope);
          mountCommerce(root, scope);
          if (!root.classList.contains('e-ssr')) mountPresentation(root, scope);
          const observer = new MutationObserver((records) => {
            if (
              records.some(
                (r) =>
                  !(r.target.nodeType === 1 ? r.target : r.target.parentElement)?.closest(
                    '.e-gallery,.e-bundle,.e-selection,.e-bundle-purchase,.e-bundle-stain-label',
                  ),
              )
            )
              scope.updates.forEach((update) => update());
          });
          observer.observe(root, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['checked', 'data-selected-variant'],
          });
          scope.cleanups.push(() => observer.disconnect());
        } else if (root.dataset.dcPdpPart === 'banner') mountBanner(root, scope);
        else mountTools(root, scope);
        root.dataset.dcPdpReady = 'true';
      });
  }
  window.DCPdp = { version: 4, mount };
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((scope, root) => {
      if (root.dataset.section === event.detail?.sectionId) {
        scope.destroy();
        instances.delete(root);
      }
    });
  });
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
